import * as React from "react";

import { Container, makeStyles } from "@material-ui/core";
import OrganizationHeader from "./components/01/OrganizationHeader";
import TabsSelection from "./components/02/TabsLoader";
import Stats from "./components/04/Stats";
import Projects from "./components/04/Projects";
import Posts from "./components/03/Posts";
import Salons from "./components/04/Salons";
import GiftCarts from "./components/05/GiftCards";
import Cards from "./components/06/Cards";
import DigiKalaCard from "./components/07/digikalaCard";
import Support from "./components/08/support";

const useStyles = makeStyles((theme) => ({
  noPaddig: {
    padding: 0,
  },
}));

const OrganizationOnePageDesktop = ({
  data,
  getData,
  stats,
  projects = [],
  posts = [],
  salons = [],
  giftCarts = [],
  digikalaData = [],
}) => {
  const classes = useStyles();
  return (
    <Container className={classes.noPaddig}>
      <OrganizationHeader data={data} />
      <TabsSelection data={data} getData={getData} />
      {posts && posts.length > 0 && <Posts posts={posts} />}
      {stats && <Stats statistics={stats} />}
      {projects && projects.length > 0 && <Projects projects={projects} />}
      {/* {digikalaData?.data && digikalaData?.data?.length > 0 && (
        <DigiKalaCard data={digikalaData} />
      )} */}
      {salons && salons.length > 0 && <Salons salons={salons} />}
      { data.has_wallet && (giftCarts && giftCarts.items && giftCarts.items.length > 0) && (
        <GiftCarts giftCarts={giftCarts.items} data={data} />
      )}
      <Cards
        data={data}
        giftCarts={giftCarts}
        salons={salons}
        projects={projects}
      />
      <Support data={data}/>
    </Container>
  );
};

export default OrganizationOnePageDesktop;
